/* === ZEHO Wishlist unified core === */
(function(){
  const KEY = 'zeho_wishlist_handles';

  function read(){
    try{
      return Array.from(new Set(JSON.parse(localStorage.getItem(KEY) || '[]'))).filter(Boolean);
    }catch{ return []; }
  }
  function write(arr){
    const uniq = Array.from(new Set(arr.filter(Boolean)));
    localStorage.setItem(KEY, JSON.stringify(uniq));
    return uniq;
  }

  // トグル関数（HTMLのonclickから呼ばれる）
  window.ZEHO_WISHLIST_TOGGLE = function(handle, btn){
    if(!handle) return;
    let list = read();
    const idx = list.indexOf(handle);
    const active = idx === -1;
    if(active) list.push(handle);
    else list.splice(idx,1);
    write(list);

    // 見た目の切替
    if(btn){
      btn.setAttribute('aria-pressed', active);
      btn.querySelector('.icon--filled').style.display = active ? 'inline' : 'none';
      btn.querySelector('.icon--outline').style.display = active ? 'none' : 'inline';
    }

    // 同期イベント（他タブにも反映）
    window.dispatchEvent(new StorageEvent('storage',{key:KEY,newValue:JSON.stringify(list)}));
  };

  // 初期状態の反映
  document.addEventListener('DOMContentLoaded', ()=>{
    const list = read();
    document.querySelectorAll('[data-zeho-wish-btn]').forEach(btn=>{
      const h = btn.getAttribute('data-handle');
      if(list.includes(h)){
        btn.setAttribute('aria-pressed', true);
        btn.querySelector('.icon--filled').style.display = 'inline';
        btn.querySelector('.icon--outline').style.display = 'none';
      }
    });
  });
})();
